import { lazy } from 'react';

const ManageSku = lazy(() => import('./ManageSku'));

export default ManageSku;
